import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CtaButtonProps {
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  children: React.ReactNode;
  price?: string;
}
export function CtaButton({
  href,
  onClick,
  className = '',
  children,
  price
}: CtaButtonProps) {
  const isScroll = href?.startsWith('#');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isScroll) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick(e);
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`relative inline-flex flex-col items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all bg-[#f97316] rounded-xl shadow-[0_8px_0_#c2410c] hover:shadow-[0_6px_0_#c2410c] hover:translate-y-[2px] active:shadow-[0_0px_0_#c2410c] active:translate-y-[8px] ${className}`} data-id="element-202">
      {price && <span className="absolute -top-4 bg-[#16a34a] text-white text-sm font-bold px-3 py-1 rounded-full shadow-md border-2 border-white" data-id="element-203">
          {price}
        </span>}
      <span className="flex items-center gap-2 text-center uppercase tracking-wide" data-id="element-204">
        {children}
        <ChevronRight className="w-6 h-6" data-id="element-205" />
      </span>
    </motion.a>;
}